<template>
  <div id="dashboard" class="py-3">
    <ReportHeader
      :reportTypeId="reportTypeId"
      :title="title"
      :subtitle="subtitle"
    />
    <div
      class="row mb-5"
      v-for="table in dashboardPage.DashboardTables"
      v-bind:key="table"
    >
      <div class="col">
        <div class="table-responsive remove-vertical-scroll">
          <table
            class="text-center font-weight-bold nowrap dashboardTable mb-0 w-100"
          >
            <thead>
              <tr class="dashboardHeadRow">
                <th
                  v-for="(header, headerIndex) in table.Headers"
                  :key="headerIndex"
                  class="dashboard-table-header dashboard-table-width"
                  :class="[
                    headerIndex === 0
                      ? 'text-left dashboard-table-first-header dashboard-table-header-radius'
                      : '',
                    headerIndex === table.Headers.length - 1
                      ? 'dashboard-table-header-radius'
                      : '',
                  ]"
                >
                  {{ header }}
                </th>
                <th
                  v-if="table.HasImportantTrendsText"
                  class="dashboard-table-header dashboard-table-header-radius"
                >
                  Important Trends
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(market, index) in table.Markets" :key="index">
                <tr
                  v-for="(metric, metricIndex) in market.Rows"
                  :key="metricIndex"
                >
                  <td
                    :rowspan="market.Rows.length"
                    v-if="metricIndex === 0"
                    class="dashboard-table-first-header"
                    :class="metricIndex === 0 ? 'dashboardTableRowTop' : ''"
                  >
                    <div class="text-left">
                      <p>
                        {{ market.SeriesName }}
                        <BaseTooltip
                          trigger="click"
                          tooltip-color="white"
                          shadow
                          arrow
                        >
                          <template #display>
                            <img
                              :id="'popperOpenBtn' + (index - 1)"
                              style="
                                min-height: 20px !important;
                                min-width: 20px !important;
                              "
                              src="/images/question-mark-gray.png"
                            />
                          </template>
                          <template #tooltip>
                            <p>
                              {{ market.Definition }}
                            </p>
                          </template>
                        </BaseTooltip>
                      </p>
                      <p v-if="market.Label !== ''" class="dashboardSubLabels">
                        {{ market.Label }}
                      </p>
                    </div>
                  </td>

                  <td
                    v-bind:key="metric"
                    :class="metricIndex === 0 ? 'dashboardTableRowTop' : ''"
                  >
                    {{ metric.Metric }}
                  </td>

                  <td
                    v-for="data in metric.MetricData"
                    v-bind:key="data"
                    :class="metricIndex === 0 ? 'dashboardTableRowTop' : ''"
                  >
                    <p
                      :class="
                        data.Phase === 'A'
                          ? 'phaseABackground'
                          : data.Phase === 'B'
                            ? 'phaseBBackground'
                            : data.Phase === 'C'
                              ? 'phaseCBackground'
                              : data.Phase === 'D'
                                ? 'phaseDBackground'
                                : data.AMP === 'N/A'
                                  ? 'phaseNABackground'
                                  : ''
                      "
                    >
                      {{ data.AMP }}
                    </p>
                  </td>

                  <td
                    v-if="table.HasImportantTrendsText && metricIndex === 0"
                    :rowspan="market.Rows.length"
                    class="dashboardTrendsText dashboardTableRowTop"
                  >
                    {{ market.TrendsText }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col text-center mb-3">
        <img src="/images/phase-group.png" />
      </div>
    </div>
    <div class="row" v-if="dashboardPage.PageNotes.length > 0">
      <div class="col">
        <div class="p-3 notes">
          <p
            v-for="note in dashboardPage.PageNotes"
            v-bind:key="note"
            v-html="note"
          ></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import BaseTooltip from '~/components/base/BaseTooltip.vue';
  import ReportHeader from '~/components/report/ReportHeader.vue';

  export default {
    name: 'DashboardPageComponent',
    components: {
      BaseTooltip,
      ReportHeader,
    },
    props: {
      companyName: String,
      companyLogo: String,
      consulting_slug: String,
      dashboardPage: Object,
      productType: String,
      reportDate: String,
      reportTypeId: {
        type: [String, Number],
        // required: true,
      },
    },
    computed: {
      title() {
        return `${this.dashboardPage.PageName}`;
      },
      subtitle() {
        return ``;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .remove-vertical-scroll {
    height: 100%;
    overflow-y: hidden;
  }
</style>
